import { useMutation } from 'react-relay';

import { simpleApplyMutation } from '@/__generated__/simpleApplyMutation.graphql';
import { simpleApply } from '@/graphql/mutation/taxRefund/simpleApply';

export const useSimpleApply = () => {
  const [commit, isInFlight] = useMutation<simpleApplyMutation>(simpleApply);
  return { commit, isInFlight };
};
